import React, { cloneElement, useCallback, useState } from "react"
import { PopupAnchor, PopupRenderCallback } from "../Popup"

export type Props = {
  id: string
  anchor: PopupAnchor
  children?: React.ReactNode | PopupRenderCallback
}

const WithOverlay: React.FC<Props> = ({ id, anchor, children }) => {
  const [open, setOpen] = useState<boolean>(false)

  const onOpen = useCallback(() => {
    setOpen(true)
  }, [])

  const onClose = useCallback(() => {
    setOpen(false)
  }, [])

  const resolvedAnchor =
    typeof anchor === "function" ? anchor({ open }) : anchor

  const anchorElement =
    resolvedAnchor &&
    cloneElement(resolvedAnchor, {
      id: resolvedAnchor.props.id ?? `${id}-toggle`,
      ["aria-controls"]: open ? `${id}-menu` : undefined,
      ["aria-haspopup"]: "true",
      ["aria-expanded"]: open ? "true" : "false",
      onClick: onOpen
    })

  const isRenderChildren = typeof children === "function"

  return (
    <>
      {anchorElement}
      {isRenderChildren
        ? (children as PopupRenderCallback)?.({ open, onClose })
        : children}
    </>
  )
}

export default WithOverlay
